import React, {Component} from "react";
import PropTypes from 'prop-types';

import {XA, XLi, XUl} from "../Layout/Layout";



class  Pagination extends Component{

    constructor(props) {
        super(props);

        this.isAlive = true;

        this.state = {open:false};
        this.bClick=this.clicked.bind(this);

        let currentPage=props.currentPage;
        let pageSize=props.pageSize;
        let total=props.total;

        let p=Math.floor((total - 1) / pageSize) + 1;
        if(currentPage>p) currentPage=p;

        this.state = {total: total,current: currentPage,pageSize:pageSize};
        this.props=props;
    }

    clicked(event) {
        event.preventDefault();
        event.stopPropagation();
        let p=event.currentTarget.getAttribute('page');
        let page=parseInt(p);
        if(page>0)  this.setState({current:page});
        if(this.props.changFun!==null){
            this.props.changFun(page);
        }
        return false;
    }

    setTotal(total) {
        let p = Math.floor((total - 1) / this.state.pageSize) + 1;
        if (p<=0) p=1;
        let current=this.state.current;
        if(current>p) current=p;
        this.setState({current:current,total:total});
        return current;
    }

    setPageSize(pageSize) {
        let p=Math.floor(( this.state.total - 1) / pageSize) + 1;
        if (p<=0) p=1;
        let current=this.state.current;
        if(current>p) current=p;
        this.setState({current:current,pageSize:pageSize});
        return current;
    }

    render() {
        let {
            className,
            period,
            hideOnSinglePage,
            hasFirst,
            hasLast,
            hasPrev,
            hasNext,
        } = this.props;

        let cp=`pagination   ${className}`;
        const { total,current,pageSize } = this.state;
        if (hideOnSinglePage === true && total <= pageSize) {
            return null;
        }

        const allPages =  Math.floor((total - 1) / pageSize) + 1;
        const prevPage = current - 1 > 0 ? current - 1 : 1;
        const nextPage = current + 1 < allPages ? current + 1 : allPages;

        let first;
        if(hasFirst){
            let c1="page-item";
            if(current===1) c1="page-item disabled";
            first=<XLi className={c1}><XA className='page-link' attrs={{page:1}} onClick={this.bClick} >اولین</XA></XLi>;
        }
        let last;
        if(hasLast){
            let c2="page-item";
            if(current===allPages) c2="page-item disabled";
            last=<XLi className={c2}><XA className='page-link' attrs={{page:allPages}} onClick={this.bClick} >آخرین</XA></XLi>;
        }
        let prev;
        if(hasPrev){
            let c3="page-item";
            if(current===prevPage) c3="page-item disabled";
            prev=<XLi className={c3}><XA className='page-link' attrs={{page:prevPage}}    onClick={this.bClick}>قبلی</XA></XLi>;
        }
        let next;
        if(hasNext){
            let c3="page-item";
            if(current===nextPage) c3="page-item disabled";
            next=<XLi className={c3}><XA className='page-link' attrs={{page:nextPage}}    onClick={this.bClick}>بعدی</XA></XLi>;
        }

        let k=0;
        let items=[];
        if(period<3){
            period=5;
        }

        let start=1;
        let end=allPages;

        if((current-period)>start){
            // Dot
            k++;
            let item = <XLi className='page-item disabled' key={k}><XA className='page-link' href='#' tabindex='-1'>...</XA></XLi>;
            items.push(item);
            start=Math.ceil(current-period/2) ;
        }

        let i=start;
        // before Current
        while(i<current) {
            k++;
            let item =<XLi className='page-item ' key={k}><XA className='page-link' href='#' attrs={{page:i}}  onClick={this.bClick}>{i}</XA></XLi> ;
            items.push(item);
            i++;
        }

        // Current
        k++;
        let itemA =<XLi className='page-item active'  key={k}><XA className='page-link' href='#' tabindex='-1'>{current}</XA></XLi>;
        items.push(itemA);

        let dotEnd=false;
        if((current+period)<end){
            end=Math.floor(current+period/2) ;
            dotEnd=true;
        }

        // after Current
        i=current+1;
        while(i<=end) {
            k++;
            let item =<XLi className='page-item '  key={k}><XA className='page-link' href='#' attrs={{page:i}}  onClick={this.bClick} >{i}</XA></XLi>;
            items.push(item);
            i++;
        }

        if(dotEnd){
            // Dot
            k++;
            let item =<XLi className='page-item disabled'  key={k}><XA className='page-link' href='#' tabindex='-1'>...</XA></XLi>;
            items.push(item);
        }

        return (
            <React.Fragment>
                <XUl className={cp}  >
                    {first}
                    {prev}
                    {items}
                    {next}
                    {last}
                </XUl>
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Pagination.propTypes = {
    className: PropTypes.string,
    pageSize: PropTypes.number,
    currentPage: PropTypes.number,
    total:PropTypes.number,
    period:PropTypes.number,
    hideOnSinglePage:PropTypes.bool,
    hasFirst:PropTypes.bool,
    hasLast:PropTypes.bool,
    hasPrev:PropTypes.bool,
    hasNext:PropTypes.bool,
    changFun:PropTypes.func,
};

Pagination.defaultProps = {
    className:"",
    pageSize:10,
    currentPage:1,
    total:1,
    period:5,
    hideOnSinglePage:true,
    hasFirst:true,
    hasLast:true,
    hasPrev:true,
    hasNext:true,
    changFun:null
};

export default Pagination;
